import React from 'react';
import {
  ErrorContext,
  ErrorContextType,
} from '@/components/ErrorContextProvider/ErrorContextProvider';
import { logger } from '@/services/logger.service';
import './ErrorBoundary.scss';

type Props = {
  children?: React.ReactNode;
  size?: string;
};

type State = {
  hasError: boolean;
};

export default class ErrorBoundary extends React.Component<Props, State> {
  static contextType = ErrorContext;
  declare context: ErrorContextType;

  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, errorInfo: React.ErrorInfo) {
    logger.critical('React component error', { error, errorInfo });
    this.context.updateError(true);
  }

  render() {
    if (this.state.hasError || this.context.hasError) {
      return (
        <div
          style={{ fontSize: this.props.size || '20px' }}
          className="error-boundary-container"
        >
          Something went wrong.
        </div>
      );
    }

    return this.props.children;
  }
}
